class ConditionsButtons extends HTMLElement {
  #variantOptions;
  #itemsInStock;
  maxLeftInStock;
  maxLeftInStockEl;

  constructor() {
    super();

    // Cache the main container
    const productInfo = this.closest("product-info");
    this.#variantOptions = productInfo.querySelector(
      ".product-options-btns__container",
    );
    this.#itemsInStock = productInfo.querySelector(".items-in-stock");
    this.maxLeftInStockEl = productInfo.querySelector(".js-only-left");
    this.maxLeftInStock = Number(this.maxLeftInStockEl?.dataset.max);

    this.filtersLogic();
    this.initializeSelection();

    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      this.updateLeftInStock();
    });
  }

  // Kick off the right selection flow based on URL
  initializeSelection() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get("variant");
    const variantsParam = params.get("variants");

    if (window.location.href.includes("/pages/suite") && variantsParam) {
      this.handleSuiteVariants(variantsParam);
    } else if (!variantId) {
      this.selectDefaultOption();
    }
  }

  handleSuiteVariants(variantsString) {
    const variants =
      this.closest("product-info").querySelectorAll(".product-variant");
    variants.forEach((variant) => {
      if (variantsString.includes(variant.dataset.variantId)) {
        this.applyConditionFilter(variant.dataset.condition);
      }
    });
    this.rebaseVarSelector();
  }

  // Click the filter whose data-value matches `conditionValue`
  applyConditionFilter(conditionValue) {
    this.querySelectorAll(".js-cb-filter").forEach((filter) => {
      if (filter.dataset.value === conditionValue) {
        filter.click();
      }
    });
  }

  selectDefaultOption() {
    const availableFilters = Array.from(
      this.querySelectorAll(
        `.js-cb-filter:not(:has(span[data-prod-option-count="0"]))`,
      ),
    );

    if (availableFilters.length > 0) {
      const firstAvailable = availableFilters[0];
      firstAvailable.click();
      this.#itemsInStock.textContent =
        this.#itemsInStock.dataset.productQty + " In-Stock";
      this.#itemsInStock
        .closest(".select-from-qty--box")
        ?.classList.remove("hidden");
    } else {
      this.#itemsInStock
        .closest(".select-from-qty--box")
        ?.classList.add("hidden");
      this.querySelectorAll(".js-cb-filter").forEach((el) =>
        el.classList.remove("ppf-checked"),
      );
    }
    this.rebaseVarSelector();
  }

  updateLeftInStock() {
    setTimeout(() => {
      //amt means amount (stock quantity)
      const amt = Number(
        this.querySelector(".js-cb-filter.ppf-checked [data-prod-option-count]")
          .dataset.prodOptionCount,
      );

      const infoBox = this.closest("product-info");
      if (amt <= this.maxLeftInStock) {
        infoBox.querySelector(".amount-left").innerHTML = amt;
        infoBox.classList.add("low-stock-info-active");
      } else {
        infoBox.classList.remove("low-stock-info-active");
      }
    }, 50);
  }

  selectFirstAvailableOption() {
    const productInfo = this.closest("product-info");
    const variants = productInfo.querySelectorAll(
      ".product-options-btns__container .product-variant",
    );

    const first = Array.from(variants).find(
      (el) =>
        !el.classList.contains("hide-variant-option") &&
        !el.classList.contains("hide-variant-option--force") &&
        Number(el.dataset.invertory) > 0,
    );

    if (first && !window.location.search.includes("old_key=")) {
      const input = first.querySelector("input");
      input.click();
      input.dispatchEvent(new Event("change", { bubbles: true }));
      this.applyConditionFilter(first.dataset.condition);
    }
  }

  showOutOfStockInfo(parent) {
    parent.querySelector(".popover-message").classList.add("active");
    setTimeout(() => {
      parent.querySelector(".popover-message").classList.remove("active");
    }, 5000);
  }

  rebaseVarSelector() {
    const checkedFilter = this.querySelector(".ppf-checked");
    const varSelects = document.querySelector("variant-selects");

    let newParent = checkedFilter?.querySelector(".variant-selects--container");

    if (!newParent) {
      newParent = document.querySelector(
        ".variant-selects--container.product-variants-container",
      );
    }

    if (!newParent || !varSelects) {
      return;
    }

    newParent.innerHTML = "";
    newParent.append(varSelects);
  }

  filtersLogic() {
    this.querySelectorAll(".js-cb-filter").forEach((filter) => {
      filter.addEventListener("click", (e) => {
        if (filter.classList.contains("ppf-checked")) return;
        const count = filter.querySelector("[data-prod-option-count]").dataset
          .prodOptionCount;
        if (count === "0") {
          this.showOutOfStockInfo(filter);
          return;
        }

        // Toggle checked class
        this.querySelectorAll(".js-cb-filter").forEach((f) =>
          f.classList.remove("ppf-checked"),
        );
        filter.classList.add("ppf-checked");

        // Show/hide product variants
        this.#variantOptions
          .querySelectorAll(".product-variant")
          .forEach((opt) => {
            opt.classList.toggle(
              "hide-variant-option",
              opt.dataset.condition !== filter.dataset.value,
            );
          });

        this.rebaseVarSelector();
        // Auto-select first available after filtering
        this.selectFirstAvailableOption();

        // Dispatch custom event
        window.dispatchEvent(
          new CustomEvent("filter::changed", {
            detail: filter.dataset.value,
          }),
        );

        // Low-stock indicator
        const amt = Number(count);
        const infoBox = this.closest("product-info");
        if (amt <= this.maxLeftInStock) {
          infoBox.classList.add("low-stock-info-active");
          this.maxLeftInStockEl.querySelector(".amount-left").innerHTML = amt;
        } else {
          infoBox.classList.remove("low-stock-info-active");
        }
      });

      filter.addEventListener("mouseover", () => {
        if (
          filter.querySelector("[data-prod-option-count]").dataset
            .prodOptionCount === "0"
        ) {
          filter.querySelector(".popover-message").classList.add("active");
        }
      });

      filter.addEventListener("mouseleave", () => {
        if (
          filter.querySelector("[data-prod-option-count]").dataset
            .prodOptionCount === "0"
        ) {
          filter.querySelector(".popover-message").classList.remove("active");
        }
      });
    });
  }
}

customElements.define("conditions-buttons", ConditionsButtons);
